import { Purchaser, PurchaserProps } from "../lookup";
import { CreditDocument, CreditDocumentProps } from "./CreditDocument";

export interface CreditProps {
    remittanceId: number;
    checkNumber: string;
    checkDate: string;
    remittanceItemId: number;
    invoiceNumber: string;
    invoiceDate: string;
    purchaser: PurchaserProps;
    grossAmount: number;
    netAmount: number;
    discountAmount: number | null;
    voucherNumber: string | null;
    poNumber: string | null;
    description: string | null;
    documents: CreditDocumentProps[];
    remittanceItemCreatedAt: string;
    remittanceItemUpdatedAt: string | null;
    remittanceItemLastUpdatedAt: string;
    isManuallyUploaded: boolean;
}

export class Credit implements CreditProps {
    private readonly _remittanceId: number;
    private readonly _checkNumber: string;
    private readonly _checkDate: string;
    private readonly _remittanceItemId: number;
    private readonly _invoiceNumber: string;
    private readonly _invoiceDate: string;
    private readonly _purchaser: PurchaserProps;
    private readonly _grossAmount: number;
    private readonly _netAmount: number;
    private readonly _discountAmount: number | null;
    private readonly _voucherNumber: string | null;
    private readonly _poNumber: string | null;
    private readonly _description: string | null;
    private readonly _documents: CreditDocument[];
    private readonly _remittanceItemCreatedAt: string;
    private readonly _remittanceItemUpdatedAt: string | null;
    private readonly _remittanceItemLastUpdatedAt: string;
    private readonly _isManuallyUploaded: boolean;

    constructor(props: CreditProps) {
        this._remittanceId = props.remittanceId;
        this._checkNumber = props.checkNumber;
        this._checkDate = props.checkDate;
        this._remittanceItemId = props.remittanceItemId;
        this._invoiceNumber = props.invoiceNumber;
        this._invoiceDate = props.invoiceDate;
        this._purchaser = Purchaser.fromJson(props.purchaser);
        this._grossAmount = props.grossAmount;
        this._netAmount = props.netAmount;
        this._discountAmount = props.discountAmount;
        this._voucherNumber = props.voucherNumber;
        this._poNumber = props.poNumber;
        this._description = props.description;
        this._documents = props.documents?.map(document => new CreditDocument(document)) ?? [];
        this._remittanceItemCreatedAt = props.remittanceItemCreatedAt;
        this._remittanceItemUpdatedAt = props.remittanceItemUpdatedAt;
        this._remittanceItemLastUpdatedAt = props.remittanceItemLastUpdatedAt;
        this._isManuallyUploaded = props.isManuallyUploaded;
    }

    public get remittanceId(): number {
        return this._remittanceId;
    }

    public get checkNumber(): string {
        return this._checkNumber;
    }

    public get checkDate(): string {
        return this._checkDate;
    }

    public get remittanceItemId(): number {
        return this._remittanceItemId;
    }

    public get invoiceNumber(): string {
        return this._invoiceNumber;
    }

    public get invoiceDate(): string {
        return this._invoiceDate;
    }

    public get purchaser(): PurchaserProps {
        return this._purchaser;
    }

    public get grossAmount(): number {
        return this._grossAmount;
    }

    public get netAmount(): number {
        return this._netAmount;
    }

    public get discountAmount(): number | null {
        return this._discountAmount;
    }

    public get voucherNumber(): string | null {
        return this._voucherNumber;
    }

    public get poNumber(): string | null {
        return this._poNumber;
    }

    public get description(): string | null {
        return this._description;
    }

    public get documents(): CreditDocument[] {
        return this._documents;
    }

    public get remittanceItemCreatedAt(): string {
        return this._remittanceItemCreatedAt;
    }

    public get remittanceItemUpdatedAt(): string | null {
        return this._remittanceItemUpdatedAt;
    }

    public get remittanceItemLastUpdatedAt(): string {
        return this._remittanceItemLastUpdatedAt;
    }

    public get isManuallyUploaded(): boolean {
        return this._isManuallyUploaded;
    }
}